import React from 'react'
import PropTypes from 'prop-types'
// TODO: Esperar diseño final del  flag
const FederationFlag = ({ flag }) => (
  <React.Fragment>
    {flag ? (
      <div className="flag">
        <div className={`flag--base flag--${flag.color_base}`}>
          <span className="icon-flag-base"> </span>
        </div>
        <div className={`flag--shadow flag--${flag.color_icon}`}>
          <span className={`icon-flag-${flag.icon}`}> </span>
        </div>
        <div className={`flag--emblem flag--${flag.color_center}`}>
          <span className={`icon-flag-forma-${flag.form}`}> </span>
        </div>
        <div className="flag--png"> </div>
      </div>
    ) : null}
  </React.Fragment>
)

FederationFlag.propTypes = {
  flag: PropTypes.object,
}

export default FederationFlag
